import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const ProcFeeConfirmationModalUI = ({ context, successMsg, errorList, setErrorList, procFeeMode, onProcFeeCancel, feeAmount,
	// modes
	submitted,
	// event handlers
	onSubmit,
}) =>
	<ModalFormUI
		context={context}
		titleLabel='Collect Processing Fee'
		buttonLabel='Confirm'
		cancelLabel='Cancel'
		isOpen={procFeeMode}
		onRequestClose={onProcFeeCancel}
		successMsg={successMsg}
		errorList={errorList}
		setErrorList={setErrorList}
		onSubmit={onSubmit}
		busy={submitted}
	>
		<InputReadOnlyUI name='amountWithTaxF1' label='Amount '
			required={true} value={feeAmount}
		/>
	</ModalFormUI>

export default ProcFeeConfirmationModalUI
